import { Component, Input } from '@angular/core';
import { TodoComponent } from '../../../common/widgets/todo/todo.component';

@Component({
	selector: 'app-cons-content',
	imports: [TodoComponent],
	templateUrl: './cons-content.component.html',
	styleUrl: './cons-content.component.scss',
})
export class ConsContentComponent {
	@Input() user: any;

}
